import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import CardParser from './pages/CardParser'
import PresetParser from './pages/PresetParser'
import { ToastProvider } from './components/Toast'

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/card" element={<CardParser />} />
            <Route path="/preset" element={<PresetParser />} />
          </Routes>
        </Layout>
      </ToastProvider>
    </BrowserRouter>
  )
}
